import { AppPavilionData } from '../components/configurator/types';
import { ImageShape } from '../lib/types';
import { axiosAPI } from './axios-instance';
import { ApiRequestFnParams, ApiResponse } from './lib/types';

export type ApiStandsRequest = {
    schemes: number[];
};

export type ApiStandResponse = ApiResponse<
    {
        id: number;
        slug: string;
        textSlug: string;
        name: string;
        index: string;
        square: number;
        size: string;
        images?: ImageShape[];
        pricePerSquare: number;
        company?: {
            id: number;
            slug: string;
            name: string;
            category_id: number;
            description?: string;
            link?: string;
            logo?: ImageShape | null;
            main_logo?: ImageShape | null;
        };
    }[]
>;

export type AppStandResponse = ApiResponse<Record<string, AppPavilionData>>;

const transformApiResponse = (response: ApiStandResponse): AppStandResponse => {
    return {
        ...response,
        data: (response.data || []).sort().reduce<Record<string, AppPavilionData>>((obj: any, arrElem: any) => {
            obj[arrElem.index.toLowerCase()] = {
                price: arrElem.pricePerSquare,
                space: arrElem.square,
                image: arrElem.images[0] || null,
                name: arrElem.name,
                textSlug: arrElem.index.toLowerCase() || '',
                slug: arrElem.index.toLowerCase(),
                url: `/constructor/${arrElem.index.toLowerCase()}/`,
                gallery: arrElem.images.map((imgShape: any) => {
                    return { img: imgShape };
                }),
                size: arrElem.size,
                ...(!!arrElem.company
                    ? {
                          booking: {
                              company: {
                                  name: arrElem.company.name,
                                  previewLogo: arrElem.company.main_logo || null,
                                  logo: arrElem.company.logo || null,
                                  description: arrElem.company.description || '',
                                  url: arrElem.company.link || '',
                              },
                          },
                      }
                    : {}),
            };
            return obj;
        }, {}),
    };
};

export const getStands = ({ params }: ApiRequestFnParams<ApiStandsRequest> = {}): Promise<AppStandResponse> =>
    axiosAPI.get<ApiStandResponse>('/v1/stands', { params }).then((res) => {
        return transformApiResponse(res.data);
    });
